<template>
  <div class="container">
    <el-row :gutter="20">
      <div class="clearfix">
        <div class="crumbs">微信设置</div>
        <div class="btn-save">
          <el-button type="primary" @click="saveClick('ruleForm')"
          >保存
          </el-button
          >
        </div>
      </div>
      <div class="form-box">
        <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width
            class="eidt-el-form"
        >
          <el-form-item label="座位号文件">
            <el-image :src="ruleForm.seatMaps"></el-image>
            <el-upload
                class="upload-demo"
                :action="action"
                :on-success="handleAvatarSuccess"
                :auto-upload="true"
                :on-change="uploadChange"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
            >
              <el-button
                  size="small"
                  type="primary"
                  plain
                  icon="el-icon-upload2"
              >上传座位文件.图片格式
              </el-button
              >
            </el-upload>
          </el-form-item>
          <div>

            <el-form-item label="1 打开微信商户平台"></el-form-item>
            <el-form-item label="2 申请JS微信支付接口"></el-form-item>
            <el-form-item
                prop="merchantId"
                label="3 设置微信商户ID和支付密钥"
                class="el-item-wrap"
            >
              <el-input
                  v-model="ruleForm.merchantId"
                  placeholder="商户ID"
                  class="wx-el-input"
              ></el-input>
            </el-form-item>
            <el-form-item
                prop="paySecret"
                label="4 设置微信商户支付密钥"
                class="el-item-wrap"
            >
              <el-input
                  v-model="ruleForm.paySecret"
                  placeholder="支付秘钥"
                  class="wx-el-input"
              ></el-input>
            </el-form-item>
            <el-form-item label="5 设置微信支付URL地址：">
              <el-input
                  v-model="buyUrl"
                  readonly=""
                  class="wx-el-input"
              ></el-input>
            </el-form-item>
            <el-form-item
                prop="appSecret"
                label="获取微信公众号密钥"
                class="el-item-wrap"
            >
              <el-input
                  v-model="ruleForm.appSecret"
                  placeholder="微信秘钥"
                  class="wx-el-input"
              ></el-input>
            </el-form-item>
            <el-form-item
                prop="appId"
                label="获取微信公众号appID"
                class="el-item-wrap"
            >
              <el-input
                  v-model="ruleForm.appId"
                  placeholder="微信AppId"
                  class="wx-el-input"
              ></el-input>
            </el-form-item>
            <el-form-item
                prop="appId"
                label="微信小程序appID"
                class="el-item-wrap"
            >
              <el-input
                  v-model="ruleForm.applicationId"
                  placeholder="小程序appID"
                  class="wx-el-input"
              ></el-input>
            </el-form-item>
            <el-form-item
                prop="appSecret"
                label="微信小程序秘钥"
                class="el-item-wrap"
            >
              <el-input
                  v-model="ruleForm.appKey"
                  placeholder="微信小程序秘钥"
                  class="wx-el-input"
              ></el-input>
            </el-form-item>
          </div>
          <div class="title-txt">3.支付宝设置</div>
          <el-form-item
              prop="appId"
              label="支付宝appID"
              class="el-item-wrap"
          >
            <el-input
                v-model="ruleForm.aliAppId"
                placeholder="支付宝appID"
                class="wx-el-input"
            ></el-input>
          </el-form-item>
          <el-form-item
              prop="appSecret"
              label="支付宝私钥"
              class="el-item-wrap"
          >
            <el-input
                v-model="ruleForm.aliPrivateKey"
                placeholder="支付宝私钥"
                class="wx-el-input"
                type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item
              prop="appSecret"
              label="支付宝公钥"
              class="el-item-wrap"
          >
            <el-input
                v-model="ruleForm.aliPublicKey"
                placeholder="支付宝私钥"
                class="wx-el-input"
                type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "editprojectmanage",
  data() {
    return {
      rules: {
        appId: [
          {required: true, message: "请输入微信公众号appId", trigger: "blur"},
        ],
        appSecret: [
          {required: true, message: "请输入微信公众号密钥", trigger: "blur"},
        ],
        merchantId: [
          {required: true, message: "请输入微信商户号", trigger: "blur"},
        ],
        paySecret: [
          {required: true, message: "请输入微信商户密钥", trigger: "blur"},
        ],
      },
      ruleForm: {
        appId: "",
        appSecret: "",
        merchantId: "",
        paySecret: "",
        projectId: "",
        applicationId: "",
        appKey: "",
        seatMaps: "",
        aliAppId: "",
        aliPublicKey: "",
        aliPrivateKey: ""
      },
      action: localStorage.getItem("url") + "/Project/Upload",
      buyUrl: localStorage.getItem("url").replace("/api", "/wechat/index/"),
    };
  },
  created() {
    this.$axios
        .get("/Project/" + localStorage.getItem("project_Id"))
        .then((res) => {
          if (res.data.hasError == false) {
            this.ruleForm = res.data.data
          }
        });
  },
  methods: {
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.$axios.put("/Project/", this.ruleForm).then((res) => {
            if (res.data.hasError == false) {
              this.$message.success("保存成功！");
              this.goBack();
              this.$refs['ruleForm'].resetFields();
            } else {

              this.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleAvatarSuccess(e) {
      if (e.hasError) {
        this.$message.error(e.message);
      }
      if (e.data) {
        this.ruleForm.seatMaps = e.data;
      }
    },
    uploadChange(file) {
    },
  },
};
</script>

<style lang="scss" scope>
.crumbs {
  color: #333;
}

.title-txt {
  color: #f20;
  height: 50px;
  line-height: 50px;
}

.el-form-item {
  margin-left: 20px;
}

.wx-el-input {
  width: 30%;
  margin-right: 20px;
}

.el-upload.el-upload--text {
  height: 35px !important;
  line-height: 35px;
  width: 180px !important;
  border: 0 !important;
}
</style>